import styled from 'styled-components/macro';
import { Col, Row } from '@yme/atoms/grid';
import { colorAccentLinkLight } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { getTextStyles } from '@yme/utils/styles';
export const RowStyled = styled(Row) `
  ${ADAPTIVE.maxWidth.desktop} {
    margin: 0;
  }
`;
export const ColStyled = styled(Col) `
  /* Define styles from mobile till desktop */
  ${ADAPTIVE.maxWidth.desktop} {
    margin-right: 0;
    margin-left: 0;
    flex: 0 0 100%;
    max-width: 100%;
  }
`;
export const FlexWrapperStyled = styled(FlexWrapper) `
  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl'};

  padding-top: 24px;
  padding-bottom: 24px;

  ${ADAPTIVE.minWidth.tablet} {
    padding-top: 32px;
    padding-bottom: 32px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    padding-top: 40px;
    padding-bottom: 48px;
  }
`;
// Styles for Tab and Table components
export const HeaderCellStyled = styled(RegularTextLevel3) `
  font-weight: 500;
`;
export const ChangeConfigurationButtonStyled = styled.button `
  ${getTextStyles('Ubuntu', 400, 16, 24)}

  color: ${colorAccentLinkLight};
  text-decoration: underline;
  cursor: pointer;

  background: none;
  border: none;
  padding: 0;
`;
export const SelectedModelWrapperStyled = styled.span `
  margin-right: 4px;
`;
